import { render } from "./MessagePopup.vue?vue&type=template&id=4b3c7f8d&scoped=true"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"

import "./MessagePopup.vue?vue&type=style&index=0&id=4b3c7f8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3c7f8d"]])

export default __exports__